<template>
  <v-card outlined class="evaluation-criteria-card">
    <v-card-title class="headline primary white--text d-flex justify-space-between align-center">
      <div>
        <v-icon left color="white">mdi-clipboard-check-outline</v-icon>
        Tiêu chí đánh giá
      </div>
      <v-btn color="white" text @click="saveEvaluation">
        <v-icon left>mdi-content-save</v-icon>
        Lưu
      </v-btn>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text class="pa-6">
      <v-form ref="form" v-model="valid">
        <template v-if="selectedStudent">
          <v-row dense>
            <v-col cols="12">
              <h3 class="mb-2 text-h5 font-weight-medium">
                <v-icon left color="primary">mdi-account</v-icon>
                Học sinh {{ selectedStudent.name }}
              </h3>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12">
              <v-card v-for="(criteria, index) in evaluationCriteria" :key="index" class="mb-6" outlined>
                <v-card-title class="py-2">
                  <v-row no-gutters align="center">
                    <v-col cols="10">{{ criteria.title }}</v-col>
                    <v-col cols="2" class="text-right">
                      <v-chip x-small :color="criteria.isRequired ? 'error' : 'primary'" text-color="white">
                        {{ criteria.isRequired ? 'Bắt buộc' : 'Tùy chọn' }}
                      </v-chip>
                    </v-col>
                  </v-row>
                </v-card-title>
                <v-card-text class="py-2">
                  <v-text-field
                    v-if="criteria.type === 'string'"
                    v-model="criteria.value"
                    :rules="criteria.isRequired ? [(v) => !!v || 'Bắt buộc nhập'] : []"
                    outlined
                    dense
                  ></v-text-field>
                  <v-text-field
                    v-else-if="criteria.type === 'number'"
                    v-model.number="criteria.value"
                    type="number"
                    :rules="criteria.isRequired ? [(v) => !!v || 'Bắt buộc nhập'] : []"
                    outlined
                    dense
                  ></v-text-field>
                  <v-radio-group
                    v-else-if="criteria.type === 'singlechoice'"
                    v-model="criteria.value"
                    :rules="criteria.isRequired ? [(v) => !!v || 'Bắt buộc chọn'] : []"
                    class="mt-0"
                    dense
                  >
                    <v-radio
                      v-for="(option, optionIndex) in criteria.selections"
                      :key="optionIndex"
                      :label="option"
                      :value="option"
                      class="my-0"
                      dense
                    ></v-radio>
                  </v-radio-group>
                  <v-item-group v-else-if="criteria.type === 'multiplechoice'" multiple class="mt-0">
                    <v-checkbox
                      v-model="criteria.value"
                      multiple
                      v-for="(option, optionIndex) in criteria.selections"
                      :key="optionIndex"
                      :label="option"
                      :value="option"
                      class="my-0"
                      hide-details
                      dense
                    ></v-checkbox>
                  </v-item-group>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <div class="d-flex justify-end">
            <v-btn color="primary" elevation="0" @click="saveEvaluation" class="px-4">
              <v-icon left>mdi-content-save</v-icon>
              Lưu
            </v-btn>
          </div>
        </template>
        <v-row v-else>
          <v-col cols="12">
            <v-alert type="info" outlined prominent dense>
              <v-row align="center" no-gutters>
                <v-col class="grow">Hãy chọn học sinh để đánh giá</v-col>
                <v-col class="shrink">
                  <v-icon>mdi-account</v-icon>
                </v-col>
              </v-row>
            </v-alert>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: {
    selectedStudent: {
      type: Object,
      default: null,
    },
    evaluationCriteria: {
      type: Array,
      default: () => [],
    },
    currentEvaluation: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      valid: true,
    }
  },
  methods: {
    ...mapActions('evaluateStudent', ['createOrUpdateEvaluateStudent']),
    validate() {
      return this.$refs.form.validate()
    },
    reset() {
      this.$refs.form.reset()
    },
    async saveEvaluation() {
      if (this.validate()) {
        try {
          const evaluationData = {
            student: this.selectedStudent.id,
            evaluate: this.currentEvaluation.id,
            value: this.evaluationCriteria.map((criteria) => ({
              id: criteria.id,
              value: criteria.value,
            })),
            class: this.currentEvaluation.class.id,
            evaluate_criteria: this.evaluationCriteria.map((i) => i.id),
          }
          await this.createOrUpdateEvaluateStudent(evaluationData)
          this.$alert.success('Đã lưu đánh giá thành công')
        } catch (error) {
          this.$alert.error('Có lỗi xảy ra khi lưu đánh giá')
        }
      }
    },
  },
  watch: {
    evaluationCriteria: {
      immediate: true,
      handler(newCriteria) {
        newCriteria.forEach((criteria) => {
          if (criteria.type === 'multiplechoice') {
            this.$set(criteria, 'value', [])
          } else {
            this.$set(criteria, 'value', null)
          }
        })
      },
    },
  },
}
</script>

<style scoped>
.evaluation-criteria-card {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.evaluation-criteria-card .v-card__text {
  flex-grow: 1;
  overflow-y: auto;
}
</style>
